<template>
  <div>
    <Select @on-change="change" v-model="value"  :clearable="true" filterable>
      <!--<Avatar  :src="'/api/upload/online/'+img" slot="prefix" size="small" v-if="img"/>-->
      <Option  :value="item.id" v-for="item in list" :label="item.lecturerName" filterable>
        <Avatar :src="'/api/upload/online/'+item.headImage"/>
        &nbsp;
        <b>{{item.lecturerName}}
          <span v-if="item.name">
            （{{item.name}}）
          </span>
        </b>
        &nbsp;
        &nbsp;
        <span style="color:#808695;font-size: 12px">{{item.description}}</span>
      </Option>
    </Select>

  </div>
</template>


<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
    },
    data(){
      return{
        list:[],
        img:0
      }
    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/lecturer/findall?page=1&limit=1000').then(function(rs){
          that.list = rs.data.data;
        });
      },
      change(){
        this.$emit('input',this.value);
        this.$emit('on-change');
        for(let i = 0;i<this.list.length;i++){
          if(this.value==this.list[i].id){
            this.img = this.list[i].headImage;
          }
        }

      },
    },
    created(){
      this.load();
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/common/field/FieldLecturer.vue